export function clearPlot(props) {
  var data = props.data,
      unCheckBox = props.unCheckBox,
      countryID = props.countryID,
      plotID = props.plotID;
  data.map(function (a) {
    unCheckBox(countryID, plotID, a._id);

    if (a.idx1) {
      if (!a.values) {
        a.idx1.map(function (b) {
          unCheckBox(countryID, plotID, b._id);

          if (b.idx2) {
            b.idx2.map(function (c) {
              unCheckBox(countryID, plotID, c._id);

              if (c.idx3) {
                c.idx3.map(function (d) {
                  unCheckBox(countryID, plotID, d._id);
                });
              }
            });
          }
        });
      }
    }

    if (a.idx1) {
      a.idx1.map(function (b) {
        unCheckBox(countryID, plotID, b._id);

        if (!b.values) {
          if (b.idx2) {
            b.idx2.map(function (c) {
              unCheckBox(countryID, plotID, c._id);

              if (c.idx3) {
                c.idx3.map(function (d) {
                  unCheckBox(countryID, plotID, d._id);
                });
              }
            });
          }
        }

        if (b.idx2) {
          b.idx2.map(function (c) {
            unCheckBox(countryID, plotID, c._id);

            if (!c.values) {
              if (c.idx3) {
                c.idx3.map(function (d) {
                  unCheckBox(countryID, plotID, d._id);
                });
              }
            }

            if (c.idx3) {
              c.idx3.map(function (d) {
                unCheckBox(countryID, plotID, d._id);
              });
            }
          });
        }
      });
    }
  });
}